const CACHE_KEY = "rxo_geo_country";
const TTL = 1000 * 60 * 60 * 24 * 30; // 30 days in ms

export async function fetchAndCacheCountry() {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        if (parsed?.country && parsed?.timestamp) {
          const age = Date.now() - parsed.timestamp;
          if (age < TTL) return parsed.country;
        }
      } catch (e) {
        // ignore parse errors and continue to fetch
      }
    }

    const res = await fetch("https://backendworker.rxo.me/geo");
    if (!res.ok) return null;
    const geo = await res.json();
    const country = geo?.geo_country || geo?.country || null;
    if (country) {
      try {
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({ country, timestamp: Date.now() }),
        );
      } catch (error) {
        // localStorage write error; ignore
        console.error("Error writing geo cache:", error);
      }
    }

    return country;
  } catch (error) {
    console.error("Error fetching geo:", error);
    return null;
  }
}
